//

import * as echarts from 'echarts'
import { getShare } from '@/api/public'

function fetchShareMock () {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        brewInfo: {
          title: '圣诞梦之夜',
          barista: '蜡笔小新',
          brewTime: '01-03 22:00',
          brewDate: '2024年01月03日 22:00',
          duration: '00:00:30'
        },
        brewParams: {
          bean: '15.0',
          water: '230',
          scale: '1:15.13',
          finalScale: '1:14.8',
          flask: '240',
          ratio: '1:15.7'
        },
        equipments: [
          { name: '手冲壶', emoji: '🫖', image: '' },
          { name: '研磨器', emoji: '', image: 'https://via.placeholder.com/100x100/FF9B44/FFFFFF?text=研磨' },
          { name: '滤杯', emoji: '🥤', image: '' },
          { name: '电子秤', emoji: '', image: 'https://via.placeholder.com/100x100/36D3E8/FFFFFF?text=秤' },
          { name: '温度计', emoji: '🌡️', image: '' },
          { name: '计时器', emoji: '⏱️', image: '' }
        ],
        tastings: [
          { name: '分享壶', emoji: '🫗', image: '' },
          { name: '品鉴杯', emoji: '☕', image: '' },
          { name: '滤纸', emoji: '🧻', image: '' },
          { name: '闻香杯', emoji: '🥃', image: '' },
          { name: '杯测勺', emoji: '🥄', image: '' },
          { name: '风味轮', emoji: '🎨', image: '' }
        ],
        coffeeBean: {
          name: '埃塞俄比亚 耶加雪菲',
          origin: '埃塞俄比亚',
          estate: '耶加雪菲',
          roastLevel: '浅度烘焙'
        },
        chartData: {
          weightArray: [100, 280, 360, 400, 430, 470, 500],
          flowRateArray: [0, 7.5, 5.2, 3.8, 2.5, 1.8, 1.2],
          avgFlowRateArray: [0, 7.5, 6.35, 5.5, 4.8, 5.6, 3.67]
        }
      })
    }, 500)
  })
}

function convertTo2DArray (array) {
  return array.map((value, index) => [index * 20, value])
}

function convertApiData (apiData) {
  const imgHost = process.env.VUE_APP_IMG_HOST || ''
  const startDate = new Date(apiData.startTime)
  const Y = startDate.getFullYear()
  const M = String(startDate.getMonth() + 1).padStart(2, '0')
  const D = String(startDate.getDate()).padStart(2, '0')
  const h = String(startDate.getHours()).padStart(2, '0')
  const min = String(startDate.getMinutes()).padStart(2, '0')

  function secondsToHMS (totalSeconds) {
    const H = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = totalSeconds % 60
    return String(H).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
  }

  function fullUrl (path) {
    if (!path) return ''
    return imgHost + path
  }

  function mapAppliance (list) {
    if (!list || !Array.isArray(list)) return []
    return list.map(item => ({
      name: item.name || '',
      emoji: '',
      image: fullUrl(item.imageUrl)
    }))
  }

  const cb = apiData.coffeeBean || {}

  return {
    brewInfo: {
      title: apiData.brewTitle || '',
      barista: apiData.nickname || '',
      brewTime: M + '-' + D + ' ' + h + ':' + min,
      brewDate: Y + '年' + M + '月' + D + '日 ' + h + ':' + min,
      duration: secondsToHMS(apiData.timerSeconds || 0)
    },
    brewParams: {
      bean: String(apiData.powderWeight || ''),
      water: String(apiData.waterWeight || ''),
      scale: '1:' + (apiData.waterPowderRatio || ''),
      finalScale: '1:' + (apiData.finalWaterPowderRatio || ''),
      flask: String(apiData.liquidWeight || ''),
      ratio: '1:' + (apiData.finalPowderLiquidRatio || '')
    },
    equipments: mapAppliance(apiData.applianceList && apiData.applianceList.qj),
    tastings: mapAppliance(apiData.applianceList && apiData.applianceList.pj),
    coffeeBean: {
      name: cb.name || '',
      origin: cb.origin || '',
      estate: cb.estate || '',
      roastLevel: cb.roastLevel || '',
      brand: cb.brand || '',
      imageUrl: fullUrl(cb.imageUrl)
    },
    chartData: {
      weightArray: apiData.weightSpots || [],
      flowRateArray: apiData.flowRates || [],
      avgFlowRateArray: apiData.avgFlowRates || [],
      flowRateTimes: apiData.flowRateTimes || []
    }
  }
}

export default {
  name: 'ShareIndex',
  data () {
    return {
      loading: true,
      dataEmpty: false,
      USE_MOCK: false,
      brewInfo: {
        title: '',
        barista: '',
        brewTime: '',
        brewDate: '',
        duration: ''
      },
      brewParams: {
        bean: '',
        water: '',
        scale: '',
        finalScale: '',
        flask: '',
        ratio: ''
      },
      equipments: [],
      tastings: [],
      coffeeBean: {
        name: '',
        origin: '',
        estate: '',
        roastLevel: ''
      },
      chartData: null,
      chartInstance: null,
      activeEquipmentIndex: 0,
      activeTastingIndex: 0
    }
  },
  mounted () {
    this.fetchAllData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  methods: {
    async fetchAllData () {
      try {
        const identity = this.$route.params.identity
        let data
        try {
          const response = await getShare(identity)
          if (!response || !response.data) {
            this.dataEmpty = true
            return
          }
          data = convertApiData(response.data)
        } catch (e) {
          if (this.USE_MOCK) {
            data = await fetchShareMock()
          } else {
            this.dataEmpty = true
            return
          }
        }

        this.brewInfo = data.brewInfo
        this.brewParams = data.brewParams
        this.equipments = data.equipments
        this.tastings = data.tastings
        this.coffeeBean = data.coffeeBean

        const { weightArray, flowRateArray, avgFlowRateArray, flowRateTimes } = data.chartData

        const hasTimes = flowRateTimes && flowRateTimes.length > 0
        const dataCount = weightArray.length

        const flowMax = Math.ceil(Math.max(...flowRateArray) / 2) * 2
        const weightMax = Math.ceil(Math.max(...weightArray) / 100) * 100

        const xAxis = hasTimes
          ? { type: 'category', data: flowRateTimes }
          : { type: 'value', min: 0, interval: 20, max: (dataCount - 1) * 20 }

        const markPoints = this.generateRandomMarkPoints(weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes)

        this.chartData = {
          ...data.chartData,
          weightData: hasTimes ? weightArray : convertTo2DArray(weightArray),
          flowRateData: hasTimes ? flowRateArray : convertTo2DArray(flowRateArray),
          avgFlowRateData: hasTimes ? avgFlowRateArray : convertTo2DArray(avgFlowRateArray),
          xAxis,
          yAxis: [
            { name: 'g/s', min: 0, interval: 2, max: flowMax },
            { name: 'g', min: 0, interval: 50, max: weightMax }
          ],
          markPoints,
          dataCount
        }
      } catch (e) {
        console.error('数据加载失败:', e)
      } finally {
        this.loading = false
        this.$nextTick(() => {
          this.initChart()
        })
      }
    },

    initChart () {
      const chartDom = this.$refs.chartRef
      if (!chartDom || !this.chartData) return

      this.chartInstance = echarts.init(chartDom)
      const { weightData, flowRateData, avgFlowRateData, xAxis, yAxis, markPoints, dataCount } = this.chartData

      const option = {
        animation: true,
        animationDuration: 1500,
        grid: {
          left: 50,
          right: 50,
          top: 40,
          bottom: dataCount > 6 ? 60 : 30
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.95)',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: { color: '#333', fontSize: 12 }
        },
        dataZoom: dataCount > 6
          ? [
            {
              type: 'slider',
              start: 0,
              end: 100,
              height: 20,
              bottom: 8,
              borderColor: '#e8e8e8',
              fillerColor: 'rgba(54, 211, 232, 0.15)',
              handleStyle: { color: '#36D3E8' },
              textStyle: { color: '#999', fontSize: 10 }
            }
          ]
          : undefined,
        legend: {
          data: ['重量', '流速', '平均流速'],
          top: 0,
          right: 0,
          itemWidth: 16,
          itemHeight: 3,
          textStyle: { color: '#999', fontSize: 12 },
          itemGap: 12
        },
        xAxis: {
          type: xAxis.type,
          ...(xAxis.type === 'category'
            ? {
              data: xAxis.data,
              boundaryGap: false
            }
            : {
              min: xAxis.min,
              max: xAxis.max,
              interval: xAxis.interval
            }),
          axisLabel: {
            color: '#999',
            fontSize: 11,
            formatter: xAxis.type === 'category'
              ? undefined
              : function (val) {
                const m = Math.floor(val / 60)
                const s = val % 60
                return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
              }
          },
          axisLine: { lineStyle: { color: '#e8e8e8' } },
          axisTick: { show: false },
          splitLine: { show: false }
        },
        yAxis: [
          {
            type: 'value',
            name: yAxis[0].name,
            nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 30, 0, 0] },
            min: yAxis[0].min,
            max: yAxis[0].max,
            interval: yAxis[0].interval,
            axisLabel: { color: '#999', fontSize: 11 },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }
          },
          {
            type: 'value',
            name: yAxis[1].name,
            nameTextStyle: { color: '#999', fontSize: 11, padding: [0, 0, 0, 30] },
            min: yAxis[1].min,
            max: yAxis[1].max,
            interval: yAxis[1].interval,
            axisLabel: { color: '#999', fontSize: 11 },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: '重量',
            type: 'line',
            yAxisIndex: 1,
            data: weightData,
            smooth: true,
            symbol: 'none',
            lineStyle: { color: '#36D3E8', width: 2 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(54, 211, 232, 0.3)' },
                { offset: 1, color: 'rgba(54, 211, 232, 0.02)' }
              ])
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 10,
              itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#36D3E8' },
              label: {
                show: true,
                color: '#fff',
                fontSize: 11,
                backgroundColor: '#36D3E8',
                borderRadius: 4,
                padding: [4, 8],
                position: 'top'
              },
              data: markPoints.filter(p => p.name === 'weight-mark')
            }
          },
          {
            name: '流速',
            type: 'line',
            yAxisIndex: 0,
            data: flowRateData,
            smooth: true,
            symbol: 'none',
            lineStyle: { color: '#FF9B44', width: 2 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 155, 68, 0.25)' },
                { offset: 1, color: 'rgba(255, 155, 68, 0.02)' }
              ])
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 10,
              itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#FF9B44' },
              label: {
                show: true,
                color: '#fff',
                fontSize: 11,
                backgroundColor: '#FF9B44',
                borderRadius: 4,
                padding: [4, 8],
                position: 'top'
              },
              data: markPoints.filter(p => p.name === 'flow-mark')
            }
          },
          {
            name: '平均流速',
            type: 'line',
            yAxisIndex: 0,
            data: avgFlowRateData,
            smooth: true,
            symbol: 'none',
            lineStyle: { color: '#926BFF', width: 2 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(146, 107, 255, 0.2)' },
                { offset: 1, color: 'rgba(146, 107, 255, 0.02)' }
              ])
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 10,
              itemStyle: { color: '#fff', borderWidth: 2, borderColor: '#926BFF' },
              label: {
                show: true,
                color: '#fff',
                fontSize: 11,
                backgroundColor: '#926BFF',
                borderRadius: 4,
                padding: [4, 8],
                position: 'top'
              },
              data: markPoints.filter(p => p.name === 'avg-mark')
            }
          }
        ]
      }

      this.chartInstance.setOption(option)
    },
    handleResize () {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    generateRandomMarkPoints (weightArray, flowRateArray, avgFlowRateArray, hasTimes, flowRateTimes) {
      const result = []

      const getX = (index) => hasTimes && flowRateTimes ? flowRateTimes[index] : index * 20

      const weightIndex = Math.floor(Math.random() * weightArray.length)
      result.push({
        name: 'weight-mark',
        coord: [getX(weightIndex), weightArray[weightIndex]],
        value: weightArray[weightIndex] + 'g'
      })

      const flowIndex = Math.floor(Math.random() * flowRateArray.length)
      result.push({
        name: 'flow-mark',
        coord: [getX(flowIndex), flowRateArray[flowIndex]],
        value: flowRateArray[flowIndex] + ' g/s'
      })

      const avgIndex = Math.floor(Math.random() * avgFlowRateArray.length)
      result.push({
        name: 'avg-mark',
        coord: [getX(avgIndex), avgFlowRateArray[avgIndex]],
        value: avgFlowRateArray[avgIndex] + ' g/s'
      })

      return result
    },
    handleEquipmentScroll () {
      this.updateActiveIndex('equipmentScroll', 'activeEquipmentIndex')
    },
    handleTastingScroll () {
      this.updateActiveIndex('tastingScroll', 'activeTastingIndex')
    },
    updateActiveIndex (scrollRef, activeIndexKey) {
      const container = this.$refs[scrollRef]
      if (!container) return
      const scrollLeft = container.scrollLeft
      const containerWidth = container.clientWidth
      const itemWidth = 100
      const gap = 12
      const padding = containerWidth / 2 - 56
      const centerX = scrollLeft + containerWidth / 2
      const index = Math.round((centerX - padding - itemWidth / 2) / (itemWidth + gap))
      const listKey = activeIndexKey === 'activeEquipmentIndex' ? 'equipments' : 'tastings'
      const maxIndex = this[listKey].length - 1
      this[activeIndexKey] = Math.max(0, Math.min(index, maxIndex))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/share/index.vue